import React from 'react'
import styles from './ArticleList.module.css'
import {withView, compose,route,resolve,mount} from 'navi'
import {useCurrentRoute, useNavigation, View, useView,useLoadingRoute} from 'react-navi'
import { join } from 'path'
import posts from '../routes/posts'
import routes from '../routes/index'

function ArticleList(props) {
  const {connect} = useView()
  const {resolvedRoutes}=useCurrentRoute().data
  return connect(
    <>
      <div className={styles.container}>
          <ul className={styles.articlelist}>
            <h2 className={styles.articlelistheading}>Recent Posts</h2>
              {useCurrentRoute().data.resolvedRoutes.map(l=>
                <li className={styles.articlelistitems} key={l.url.href}>
                <small><a href={l.url.href}>
                  {l.title}<br/>
                </a>
                {l.data.date.toLocaleDateString()}
                </small>
              </li>)}
          </ul>
      </div>
    </>)
}
export default ArticleList
